(function ($) {
  $("a.uk-navbar-toggle").on("click", function () {
    // switch the background color to dark colour
    $(".header-section").toggleClass("mobile-dark-header");
    $(".uk-navbar-dropdown").toggleClass("mobile-dark-header");

    // Prevent scrolling when hamburger menu is open
    $("body").toggleClass("no-scroll");

    $(".header-container .social-links-container").toggleClass("hide-items");
    $(".header-container .logo-image-container").toggleClass("hide-items");
    $(".header-container .header-items .header-links").toggleClass("hide-items");
    
    $(".header-container .header-items .mobile-menu-logo").toggleClass("show-items");
    $(".header-container .mobile-gap").toggleClass("show-items");
  });

})(jQuery);
